module.exports = __webpack_public_path__ + "img/gmail.758b1538.png";